import * as mime from 'react-native-mime-types'

import {
  getCropString,
  getScaleString,
  upspaceCoverDimension,
} from 'utils/files/fileTransformations'
import { uploadFile } from 'utils/queries'

import { SelectedFile } from 'types/file'
import { Media, MediaCrop } from 'types/media'
import { ProgramType } from 'types/program'

import { useMutation } from './useMutation'

interface UploadOptions {
  data: { crop: MediaCrop; file: SelectedFile | Media; programId: string }
}

export const useCoverUpload = (type: ProgramType) =>
  useMutation(async (data: UploadOptions) => {
    if (!type) throw new Error('Please provide type to `useCoverUpload`')

    const {
      data: { crop, file, programId },
    } = data
    if (!file) {
      throw new Error('Invalid file selected, please try again')
    }

    let fileMimeType = 'image/jpeg'
    let fileToUpload: SelectedFile | string = ''
    if ('lastModified' in file) {
      fileToUpload = file
      fileMimeType = file.type
    } else if ('url' in file) {
      fileToUpload = file.url
      fileMimeType = file.mimeType
    } else if ('base64' in file) {
      const extension = file.uri.split('.')
      fileMimeType = mime.contentType(extension[1])
      fileToUpload = `data:${fileMimeType};base64,${file.base64 || ''}`
    }

    const response = await uploadFile({
      file: fileToUpload,
      fileName: programId,
      fileType: 'image',
      transformation: `${getCropString(crop)}/${getScaleString(
        upspaceCoverDimension,
        upspaceCoverDimension,
      )}`,
      uploadPreset: type === ProgramType.GROUP ? 'upspaceCover' : 'programCover',
    })

    const body = await response.json()

    return {
      crop,
      dimensions: {
        width: upspaceCoverDimension,
        height: upspaceCoverDimension,
      },
      mimeType: fileMimeType,
      url: body.secure_url,
      _original: body,
    }
  })
